import React from 'react'
import { useModelKey } from '@morningtrain/react-resources'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function ChosenInventoryItems () {
  const categoryId = useModelKey()
  const key = ['globals.inventory.supplier_categories', categoryId].join('.')
  const [activeCategories] = useEnvValue(key, null)

  if (activeCategories == null) {
    return null
  }

  if (activeCategories.length === 0) {
    return (
      <input type='hidden' value='all' name={`chosen_items[${categoryId}]`} />
    )
  }

  return (
    activeCategories.map((item) => {
      return (
        <input type='hidden' value={item} name={`chosen_items[${categoryId}][]`} />
      )
    })
  )
}
